import React, { useEffect, useState } from "react";
import axios from "axios";
import NewHeader from "../components/NewHeader";
import Footer from "../components/footer";

export default function PrivacyPolicyPage() {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getContent = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/terms-conditions/get-terms?type=privacy-policy`
        );
        if (response.data.statusCode === 200) {
          setContent(response.data.result.content);
        }
      } catch (error) {
        console.error(error);
      }
      setLoading(false);
    };

    getContent();
  }, []);

  return (
    <>
      <NewHeader />
      <div className="max-w-5xl mx-auto px-4 md:px-8 py-16 min-h-[50vh]">
        <h1 className="text-3xl font-semibold text-[#3d0000] mb-8">
          Privacy Policy
        </h1>
        {loading ? (
          <p>Loading...</p>
        ) : content ? (
          <div
            className="prose max-w-none"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        ) : (
          <p>Privacy policy content will be available here soon.</p>
        )}
      </div>
      <Footer />
    </>
  );
}
